import { api } from '@/plugins'
import { GET_LIGNES, GET_LIGNES_SUCCESS, GET_LIGNES_FAIL } from './mutations'

export default {
  list ({ commit }, caisseId) {
    return new Promise((resolve, reject) => {
      commit(GET_LIGNES)

      api
        .GET('caisse/listLignes', caisseId)
        .then(async datas => {
          await commit(GET_LIGNES_SUCCESS, datas)
          resolve(datas)
        })
        .catch(e => {
          commit(GET_LIGNES_FAIL)
          reject(e)
        })
    })
  }
}
